import React, { useState } from 'react';
import { a2aDeveloperService } from '../../a2a/services/a2aDeveloperService.js';
import './APIPlaygroundModule.css';

const APIPlaygroundModule = ({ currentUser, onBack, onTabChange }) => {
  const [endpoint, setEndpoint] = useState('/api/v1/users');
  const [method, setMethod] = useState('GET');
  const [headers, setHeaders] = useState({ 'Content-Type': 'application/json' });
  const [headersText, setHeadersText] = useState(JSON.stringify({ 'Content-Type': 'application/json' }, null, 2));
  const [body, setBody] = useState('');
  const [response, setResponse] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleTest = async () => {
    if (!endpoint.trim()) {
      setError('請輸入 API 端點');
      return;
    }

    setLoading(true);
    setError('');
    setResponse(null);

    try {
      let parsedHeaders = {};
      try {
        parsedHeaders = JSON.parse(headersText);
      } catch (err) {
        setError('Headers JSON 格式錯誤');
        setLoading(false);
        return;
      }

      let parsedBody = undefined;
      if (method !== 'GET' && body.trim()) {
        try {
          parsedBody = JSON.parse(body);
        } catch (err) {
          setError('Body JSON 格式錯誤');
          setLoading(false);
          return;
        }
      }

      const result = await a2aDeveloperService.testAPIEndpoint({
        endpoint: endpoint.trim(),
        method,
        headers: parsedHeaders,
        body: parsedBody,
        tenant_id: currentUser?.tenant_id || 'tn_01'
      });

      if (result.success) {
        setResponse(result.data);
      } else {
        setResponse({ error: result.error || 'Unknown error' });
      }
    } catch (err) {
      setResponse({ error: err.message });
    } finally {
      setLoading(false);
    }
  };

  const handleHeadersChange = (value) => {
    setHeadersText(value);
    try {
      const parsed = JSON.parse(value);
      setHeaders(parsed);
      setError('');
    } catch (err) {
      // Invalid JSON, but keep the text for editing
    }
  };

  return (
    <div className="api-playground-module">
      <div className="module-header">
        <button onClick={onBack} className="back-btn">← 返回</button>
        <h2>API 測試平台</h2>
      </div>

      {error && (
        <div className="error-message">{error}</div>
      )}

      <div className="playground-container">
        <div className="request-panel">
          <div className="request-config">
            <select 
              value={method} 
              onChange={(e) => setMethod(e.target.value)}
              className="method-select"
            >
              <option value="GET">GET</option>
              <option value="POST">POST</option>
              <option value="PUT">PUT</option>
              <option value="DELETE">DELETE</option>
              <option value="PATCH">PATCH</option>
            </select>
            <input
              type="text"
              placeholder="API Endpoint (例如: /api/v1/users)"
              value={endpoint}
              onChange={(e) => setEndpoint(e.target.value)}
              className="endpoint-input"
            />
            <button 
              onClick={handleTest} 
              disabled={loading || !endpoint.trim()}
              className="test-btn"
            >
              {loading ? '測試中...' : '發送請求'}
            </button>
          </div>
          
          <div className="request-body">
            <div className="request-section">
              <label>Headers (JSON):</label>
              <textarea
                value={headersText}
                onChange={(e) => handleHeadersChange(e.target.value)}
                className="code-textarea"
                rows={6}
                placeholder='{"Content-Type": "application/json", "Authorization": "Bearer token"}'
              />
            </div>
            
            {method !== 'GET' && (
              <div className="request-section">
                <label>Body (JSON):</label>
                <textarea
                  value={body}
                  onChange={(e) => setBody(e.target.value)}
                  className="code-textarea"
                  rows={8}
                  placeholder='{"key": "value"}'
                />
              </div>
            )}
          </div>
        </div>
        
        <div className="response-panel">
          <h3>Response:</h3>
          {loading ? (
            <div className="loading">發送請求中...</div>
          ) : response ? (
            <pre className="response-content">
              {JSON.stringify(response, null, 2)}
            </pre>
          ) : (
            <div className="empty-response">
              <p>點擊「發送請求」來測試 API</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default APIPlaygroundModule;

